import * as React from 'react';
import { graphql } from 'gatsby';
import s from './ArticleTemplate.module.scss';

export interface Props {
  id: number;
  text: string;
  internal: {
    type: string;
  };
}

class TextBlock extends React.Component<Props> {
  render() {
    const { text } = this.props;
    return (
      <div className={s.textBlock} dangerouslySetInnerHTML={{ __html: text }} />
    );
  }
}

export const query = graphql`
  fragment Article_TextBlockFragment on WordPressAcf_text {
    ... on WordPressAcf_text {
      id
      text
      internal {
        type
      }
    }
  }
`;

export default TextBlock;
